import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { api } from "../../App/API/api";

export const fetchAidData = createAsyncThunk("aid/fetchData", async () => {
    try {
        const response = await api.get("/aids");
        console.log("aid ",response)
        const data = response.data.data;
        return data;
    } catch (error) {
        return error;
    }
});

export const aidSlice = createSlice({
    name: "aid",
    initialState: {
        loading: false,
        error: null,
        aids: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchAidData.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchAidData.fulfilled, (state, action) => {
                state.loading = false;
                state.aids = action.payload;
            })
            .addCase(fetchAidData.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
            });
    },

})


export default aidSlice.reducer